import { render } from "./CustomWysiwyg.vue?vue&type=template&id=67752857&scoped=true"
import script from "./CustomWysiwyg.vue?vue&type=script&lang=js"
export * from "./CustomWysiwyg.vue?vue&type=script&lang=js"

import "./CustomWysiwyg.vue?vue&type=style&index=0&id=67752857&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67752857"]])

export default __exports__